/**
 * Small pure helpers behind the check-in screens and My day
 * (design: weco2/homework-desk.jsx `hwdTime`, `hwdGreet`, `hwdFirst`).
 */
import i18n from "../../../i18n";

/** "08:45" — the design's 24-hour clock, in the reader's own digits. */
export function clockTime(value: Date | string | number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const locale = i18n.language?.startsWith("ar") ? "ar" : "en-GB";
  return date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
}

/** "Tuesday, October 20" — the over-line on the check-in screens and My day. */
export function longDate(value: Date = new Date()): string {
  const locale = i18n.language?.startsWith("ar") ? "ar" : "en-US";
  return value.toLocaleDateString(locale, { weekday: "long", month: "long", day: "numeric" });
}

export type GreetingKey = "morning" | "afternoon" | "evening";

/** The design's three greetings, by the reader's local hour. */
export function greetingFor(date: Date = new Date()): GreetingKey {
  const hour = date.getHours();
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

export function firstName(name: string | null | undefined): string {
  return (name ?? "").trim().split(/\s+/)[0] ?? "";
}

/** "AB" for a desk's taken badge (design `hwInitials`). */
export function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}
